/**
 * @Author: DKing
 * @Desc: hvyogo-web
 * @Date: 2019-09-19
 */
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = {
  state: {
    
  },

  mutations: {

  },

  getters:{

  },

  actions:{

  }

}


export default new Vuex.Store({
  store
})



// WEBPACK FOOTER //
// ./src/store/store.js